export default [
    {
        path: '/admin/report/cash-request-reports',
        name: 'report-cash-request-report',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/finance/cash-request-report.vue')
    },
    {
        path: '/admin/report/cash-transfer-reports',
        name: 'report-cash-transfer-report',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/finance/cash-transfer-report.vue')
    }
]
